import { Component, Inject, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators, ReactiveFormsModule } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogTitle, MatDialogContent, MatDialogActions } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';

import { CdkScrollable } from '@angular/cdk/scrolling';
import { MatLabel, MatFormField } from '@angular/material/form-field';
import { MatInput } from '@angular/material/input';
import { MatCheckbox } from '@angular/material/checkbox';
import { MatButton } from '@angular/material/button';
import { PlayerListService } from '../../../shared/services/player-list.service';

@Component({
    selector: 'app-ranking-list-copy-dialog',
    templateUrl: './ranking-list-copy-dialog.component.html',
    styleUrls: ['./ranking-list-copy-dialog.component.css'],
    imports: [MatDialogTitle, ReactiveFormsModule, CdkScrollable, MatDialogContent, MatLabel, MatFormField, MatInput, MatCheckbox, MatDialogActions, MatButton]
})
export class RankingListCopyDialogComponent implements OnInit {

  _form: UntypedFormGroup;
  ctrlCopySecurity = new UntypedFormControl;
  ctrlCopyCategory = new UntypedFormControl;
  
  constructor(public formBuilder: UntypedFormBuilder,
    public dialogRef: MatDialogRef<RankingListCopyDialogComponent>,
    public playerListService: PlayerListService,    
    @Inject(MAT_DIALOG_DATA) public data: {CopyFromListId: string, CopyFromListName: string, CopyFromCategory: string}) {

    this._form = this.formBuilder.group({      
      CopyFromListId: data.CopyFromListId,     
      CopyToListName: ['', [Validators.required]],
      ctrlCopyCategory:'',
      ctrlCopySecurity: ''    
  });


  }

  submit(){
   /*  console.log(this.ctrlCopyCategory);
    // console.log(this._form.get('ctrlCopyCategory')); */
    var category='';
    var categoryControl = this._form.get('ctrlCopyCategory');
    if( categoryControl && categoryControl.value){
      category = this.data.CopyFromCategory; 
    }
    // console.log('Category:' + category);
    // console.log('CopyFromListId:' + this.data.CopyFromListId);
    this.playerListService.copyList(
      this.data.CopyFromListId,
      this._form.controls['CopyToListName'].value, 
      category, 
      this._form.get('ctrlCopySecurity') ? this._form.get('ctrlCopySecurity')!.value : null).subscribe(result => {
        this.dialogRef.close(result);
      
    });
  }

 

  ngOnInit(): void {
  }

  close(){
    this.dialogRef.close(false);
  }

}
